import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'stablingFilter',
  pure: false
})
export class StablingFilterPipe implements PipeTransform {

transform(items: any[], filter: Object): any {
        if (!items || !filter) {
            return items;
        }
        // filter items array, items which match and return true will be
        // kept, false will be filtered out
        return items.filter(item => item.categorize_as_stabling == filter);
    }

}

